import { Button } from '@uhg-abyss/web/ui/Button';
import { useTranslation } from 'react-i18next';

import { IconZoomIn, IconZoomOut } from './AmazonIconZoom';
import { LocateMe } from './AmazonLocateMe';
import { MapControlContainer, ZoomButton } from './AmazonMapDisplay.styled';

type Props = {
  map: any;
  showZoomButtons: boolean;
};
export const MapControlDesktop = ({ map, showZoomButtons }: Props) => {
  const { t } = useTranslation();
  const hidePopUp = () => {
    Array.from(document.getElementsByClassName('maplibregl-popup')).forEach(
      (el) => el.remove()
    );
  };
  return (
    <MapControlContainer
      alignItems="center"
      css={{ right: '$md' }}
      direction="column"
    >
      {!showZoomButtons && (
        <ZoomButton
          alignItems="center"
          direction="column"
          justify="space-between"
        >
          <Button
            aria-label={t('LOCATION_FOCUS_BOX.ZOOM_IN')}
            data-auto-testid="zoom-in"
            data-testid="zoom-in"
            onClick={() => {
              hidePopUp();
              map?.zoomIn();
            }}
            size="$sm"
            variant="text"
          >
            <IconZoomIn />
          </Button>
          <Button
            aria-label={t('LOCATION_FOCUS_BOX.ZOOM_OUT')}
            data-auto-testid="zoom-out"
            data-testid="zoom-out"
            onClick={() => {
              hidePopUp();
              map?.zoomOut();
            }}
            size="$sm"
            variant="text"
          >
            <IconZoomOut />
          </Button>
        </ZoomButton>
      )}
      <LocateMe map={map} />
    </MapControlContainer>
  );
};
